<template>
  <div class="menuContainer">
    <p class="title">投资理财</p>
    <el-menu
      :default-active="activeProduct"
      class="el-menu-demo"
      mode="vertical"
      unique-opened
      router
      text-color="#333"
    >
      <el-menu-item index="/investAndFinancing/financialProduct"
        >理财</el-menu-item
      >
      <el-menu-item index="/investAndFinancing/commissionFund"
        >代销基金</el-menu-item
      >
      <el-menu-item index="/investAndFinancing/consignmentManagementTrust"
        >代销资管信托</el-menu-item
      >
      <el-menu-item index="/investAndFinancing/consignmentInsurance"
        >代销保险</el-menu-item
      >
      <el-menu-item index="/investAndFinancing/commissionGold"
        >代销实物金</el-menu-item
      >
      <el-menu-item index="/investAndFinancing/combinationTreasure"
        >组合宝</el-menu-item
      >
    </el-menu>
  </div>
</template>

<script>
export default {
  computed: {
    activeProduct() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss"></style>
